import { TreeNode } from "@/types/tree";
import { documentStore } from "@/store/store";
import { treeNodeReduce } from "@/lib/tree/tree";
import { IMAGE_SLUG } from "@/lib/elements/constants";
import { breakdanceUndo } from "@/lib/undo/undo";

export type ImageElementDimensions = {
  elementId: TreeNode["id"];
  renderedWidthPx: number;
  renderedHeightPx: number;
};

function getImageDimensionsForAllImagesInDocument(): ImageElementDimensions[] {
  const treeRoot = documentStore.document.tree.root;

  return treeNodeReduce(
    (node: TreeNode, acc: ImageElementDimensions[]) => {
      if (node.data.type === IMAGE_SLUG) {
        const imgElement = window.Breakdance.canvas.document.querySelector(
          `img[data-node-id="${node.id}"]`
        ) as HTMLImageElement;

        if (imgElement) {
          const dimensions: ImageElementDimensions = {
            elementId: node.id,
            renderedWidthPx: imgElement.offsetWidth,
            renderedHeightPx: imgElement.offsetHeight
          };

          acc.push(dimensions);
        }
      }

      return acc;
    },
    treeRoot,
    []
  );
}

function storeImageDimensionsInNodes(
  imageDimensions: ImageElementDimensions[]
) {
  imageDimensions.forEach(dimensions => {
    documentStore.unthrottledPropertyChanged({
      elementId: dimensions.elementId,
      path: "meta.imageDimensions",
      value: {
        renderedWidthPx: dimensions.renderedWidthPx,
        renderedHeightPx: dimensions.renderedHeightPx
      },
      meta: {
        snapshotLabel: `Store image dimensions for node ${dimensions.elementId}`
      }
    });
  });
}

export function populateImageDimensions() {
  const imageDimensions = getImageDimensionsForAllImagesInDocument();
  breakdanceUndo.ignore(() => {
    storeImageDimensionsInNodes(imageDimensions);
  });
}

declare global {
  interface Window {
    populateImageDimensions: () => void;
  }
}

export function initPopulateImageDimensions() {
  window.populateImageDimensions = populateImageDimensions;
}
